import type { GameEvent } from './gameEvents';

export type GameEventHandler = (event: GameEvent) => void;

export class GameEventBus {
  private readonly handlers = new Set<GameEventHandler>();
  private readonly recentEvents: GameEvent[] = [];

  subscribe(handler: GameEventHandler): () => void {
    this.handlers.add(handler);
    return () => this.handlers.delete(handler);
  }

  publish(event: GameEvent): void {
    this.recentEvents.unshift(event);
    this.recentEvents.length = Math.min(this.recentEvents.length, 8);
    for (const handler of this.handlers) handler(event);
  }

  getRecentEvents(): readonly GameEvent[] {
    return this.recentEvents;
  }
}
